import {
  BulkActionContainerCol,
  Button,
  Col,
  PlusIcon,
  RemoveIcon,
  Table,
  TableActionBarRow,
} from "melco-ui";
import { useTranslation } from "react-i18next";
import {
  BulkActionCount,
  FormattedDate,
  ReportingMelcoMachineStatisticsModelsGroupListItem,
  Search,
  useTableSelection,
} from "melco-shared-logic";
import { useMachineGroups } from "../../../hooks/reporting/useMachineGroups";
import { useAddRemoveMachineGroups } from "../../../hooks/reporting/useAddRemoveMachineGroup";
import { BulkActionAddMachineGroups } from "../statistics/BulkActionAddMachineGroups";

export type MachineGroupsListProps = {};

export const MachineStatusAddMachineGroupsList: React.FC<
  MachineGroupsListProps
> = ({}) => {
  const { t } = useTranslation();

  const {
    data,
    errorComponent,
    isLoading,
    onTableConfigChange,
    searchQueryChange,
  } = useMachineGroups();

  const { isAlreadyAdded, addGroups, removeGroups } =
    useAddRemoveMachineGroups();

  const columns = [
    {
      title: t("reporting.machinestatus.view.machinegroups.list.columns.name"),
      key: "name",
      dataIndex: "name",
      sorter: true,
    },
    {
      title: t(
        "reporting.machinestatus.view.machinegroups.list.columns.machines"
      ),
      key: "machine_count",
      dataIndex: "machine_count",
      sorter: true,
    },
    {
      title: t(
        "reporting.machinestatus.view.machinegroups.list.columns.created"
      ),
      key: "created_date",
      dataIndex: "created_date",
      sorter: true,
      render: (
        _: string,
        item: ReportingMelcoMachineStatisticsModelsGroupListItem
      ) => <FormattedDate date={item.created_date} />,
    },
    {
      title: t(
        "reporting.machinestatus.view.machinegroups.list.columns.last_modified"
      ),
      key: "updated_date",
      dataIndex: "updated_date",
      sorter: true,
      render: (
        _: string,
        item: ReportingMelcoMachineStatisticsModelsGroupListItem
      ) => <FormattedDate date={item.updated_date} />,
    },

    {
      title: "",
      render: (rowObj: ReportingMelcoMachineStatisticsModelsGroupListItem) => {
        return isAlreadyAdded(rowObj) ? (
          <Button
            icon={<RemoveIcon />}
            onClick={() => removeGroups([{ id: rowObj.id! }])}
          >
            {t(
              "reporting.machinestatus.view.machinegroups.list.columns.remove"
            )}
          </Button>
        ) : (
          <Button
            icon={<PlusIcon />}
            type="primary"
            onClick={() => addGroups([rowObj])}
          >
            {t("reporting.machinestatus.view.machinegroups.list.columns.add")}
          </Button>
        );
      },
    },
  ];

  const { selectedRowKeys, setSelectedRowKeys, rowSelection, onRow } =
    useTableSelection<ReportingMelcoMachineStatisticsModelsGroupListItem>(
      () => {}
    );

  return (
    <>
      <TableActionBarRow>
        <Col>
          <div data-cy-id="machinestatus-view-add-machine-group-search">
            <Search
              onSearchInputChange={(query: string) => searchQueryChange(query)}
            />
          </div>
        </Col>
        <BulkActionContainerCol>
          <BulkActionCount selectedCount={selectedRowKeys.length} />
          <BulkActionAddMachineGroups
            allMachineGroups={data}
            selectedRowKeys={selectedRowKeys}
            setSelectedRowKeys={setSelectedRowKeys}
          />
        </BulkActionContainerCol>
      </TableActionBarRow>

      <Table
        dataSource={data}
        columns={columns}
        rowKey="name"
        onChange={onTableConfigChange}
        onRow={onRow}
        rowSelection={rowSelection}
        noDataMessage={t("reporting.machinegroups.list.empty")}
        loading={isLoading}
        errorComponent={errorComponent}
      />
    </>
  );
};
